import { Box, Heading, Body, BoxProps } from '@hover/blueprint';
import React from 'react';

interface Props extends BoxProps {}

const ProductionHeader: React.FC<Props> = props => (
  <Box flexDir="column" alignItems="flex-start" {...props}>
    <Body letterSpacing="1px" isBold size={200} color="neutral.600" mb={200}>
      PRODUCTION
    </Body>
    <Heading
      fontWeight={{ base: 600, desktop: 600 }}
      size={{ base: 500, tablet: 600 }}
      style={{ marginBottom: 0 }}
    >
      Simple Production Solutions
    </Heading>
  </Box>
);

export default ProductionHeader;
